import { api } from "./api";

/* analyticsApi — admin client for the real analytics dashboard (F6 3b). */
const BASE = "/analytics";

export const analyticsApi = {
  funnel:        () => api.get(`${BASE}/funnel`),
  topProperties: () => api.get(`${BASE}/top-properties`),
  sources:       () => api.get(`${BASE}/sources`),
  conversion:    () => api.get(`${BASE}/conversion`),
};
